import { useAppSelector } from 'store/hooks';
import { ViewEmailCampaigns } from 'features/Marketing/ViewEmailCampaigns';

const ViewEmailCampaignsPage = () => {
	const { isPunchup } = useAppSelector((state) => state.auth);

	return <ViewEmailCampaigns isPunchup={isPunchup} />;
};

export default ViewEmailCampaignsPage;
